/**
 * ⚠️ SUBMODULE SYNC — NEW FILE (crono-fe-common).
 * This module is new and lives only in this submodule commit. When you bump the
 * crono-fe-common submodule in crono-app-v2, make sure this file is included and
 * wire the web app's `useFindNew*` hooks to fire these same events / return this
 * `FindNewSource` discriminator, so extension and web app stay aligned.
 * Remove this note once both repos consume it.
 *
 * Analytics event names reported when a FindNew lookup is served from Crono's
 * internal DB (`...Internal`) vs. the live LinkedIn/voyager fallback (`...Linkedin`).
 *
 * These VALUES are shared verbatim between the Chrome extension background
 * services and the crono-app-v2 web hooks so both send identical Amplitude
 * events. Do not rename the string values without updating both consumers.
 */
export enum FindNewSourceAnalyticsEvent {
  CompanyInfoInternal = 'companyInfoInternal',
  CompanyInfoLinkedin = 'companyInfoLinkedin',
  CompanyInfoByNumericIdInternal = 'companyInfoByNumericIdInternal',
  CompanyInfoByNumericIdLinkedin = 'companyInfoByNumericIdLinkedin',
  ProfileViewInternal = 'profileViewInternal',
  ProfileViewLinkedin = 'profileViewLinkedin',
  UserExperienceInternal = 'userExperienceInternal',
  UserExperienceLinkedin = 'userExperienceLinkedin',
}

/**
 * Discriminator returned by FindNewWithFallbackService.
 * 'FindNew'  -> data came from Crono's internal DB (a `...Internal` event fired)
 * 'Linkedin' -> the LinkedIn fallback path was taken (a `...Linkedin` event fired
 *               only if it returned data)
 */
export type FindNewSource = 'FindNew' | 'Linkedin';
